import { render, staticRenderFns } from "./ConnectGameAccountContainer.vue?vue&type=template&id=2d3465b7&scoped=true&"
import script from "./ConnectGameAccountContainer.vue?vue&type=script&lang=ts&"
export * from "./ConnectGameAccountContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3465b7",
  null
  
)

export default component.exports